import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from 'app/service/authentication.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { MessageProvider } from '../service/message.service';

import { BusyProvider } from 'app/service/busy.service';
import { Subject } from 'rxjs/Subject';
import { UserContext } from '../core/core.component';
import { AppConstants } from './app.constants';

@Injectable()
export class AuthAccessProvider implements CanActivate {
 
    private userContext = new Subject<UserContext>();

    private currentlyEmbodying = new BehaviorSubject<boolean>(false)

    constructor(
        private router: Router,
        private auth: AuthenticationService,
        private msg: MessageProvider,
        private busyProvider: BusyProvider,


    ) {
        if (sessionStorage.getItem(AppConstants.CURRENTLY_EMBODYING)) {
            this.currentlyEmbodying.next(true)
        }
    }
   
    canActivate() 
    {
        if (sessionStorage.getItem(AppConstants.UCTX_KEY)) {
            return true;
        } 
        this.router.navigate(['/login']);
        return false;
    }
    
    getUserContext(): UserContext
    {
        var userCtx: UserContext = null;
        if (sessionStorage.getItem(AppConstants.UCTX_KEY)) {
            userCtx = JSON.parse(sessionStorage.getItem(AppConstants.UCTX_KEY));
        } 
        return userCtx;
    }
    
    setUserContext(userCtx: UserContext)
    {
        if(userCtx != null && typeof(userCtx) != 'undefined') {
           sessionStorage.setItem(AppConstants.UCTX_KEY, JSON.stringify(userCtx));
           this.userContext.next(userCtx);
        }
    }

    embodyUser(id: string) {
        if (!id) { return; }

        this.busyProvider.showBusyIndicator()

        this.auth.embody(this.getUserContext().srmToken, id).subscribe(
            res => {
                res.srmToken = this.getUserContext().srmToken;
                this.setUserContext(res);
                sessionStorage.setItem(AppConstants.CURRENTLY_EMBODYING, JSON.stringify(true));
                this.currentlyEmbodying.next(true);
                this.busyProvider.hideBusyIndicator()
                location.reload()
            },
            err => {
                let error = err.json()
                this.msg.notifyError(error.message)
                this.busyProvider.hideBusyIndicator()
            }
        )
    }

    deEmbodyUser() {
        this.busyProvider.showBusyIndicator()

        this.auth.deactivateEmbody(this.getUserContext().srmToken).subscribe(
            res => {
                res.srmToken = this.getUserContext().srmToken;
                this.setUserContext(res);
                sessionStorage.removeItem(AppConstants.CURRENTLY_EMBODYING);
                this.currentlyEmbodying.next(false);
                this.busyProvider.hideBusyIndicator()

                location.reload()
            },
            err => {
                let error = err.json()
                this.msg.notifyError(error.message)
                this.busyProvider.hideBusyIndicator()
            }
        )
    }


    public get isCurrentlyEmbodying(): boolean {
        return this.currentlyEmbodying.value
    }

    getUserContextAsObservable(): Observable<UserContext> {
        return this.userContext.asObservable();
    }
    
    invalidate() {
        sessionStorage.removeItem(AppConstants.UCTX_KEY);
        sessionStorage.removeItem(AppConstants.CURRENTLY_EMBODYING)
        this.userContext.next();
        this.router.navigate(['/login']);
    }
    
}


// WEBPACK FOOTER //
// ./src/app/core/core.auth.ts